<template>
    <div>
        <div class="wrap1200 breadcrumb">
            <breadcrumb></breadcrumb>
        </div>
        <div class="wrap1200 mineMain">
            <el-tabs v-model="activeTab" tab-position="left">
                <el-tab-pane name="userInfo" label="用户信息" style="margin-left: 20px;">
                    <div class="rightMain">
                        <div class="userInfo-Top">
                            <span>用户信息</span>
                            <div>
                                <el-button @click="goEdit" type="text">编辑信息</el-button>
                                <el-button @click="handleLogout" type="text">退出</el-button>
                            </div>
                        </div>
                        <div class="userInfo-Bottom">
                            <div class="userInfo-BLeft">
                                <el-avatar :size="120" :src="'https://api.goucaiwang888.com'+userAvatar"></el-avatar>
                            </div>
                            <div class="userInfo-BRight">
                                <el-descriptions title="">
                                    <el-descriptions-item label="用户名">{{ this.originalForm.username }}</el-descriptions-item>
                                    <el-descriptions-item label="手机号">{{ this.originalForm.mobile }}</el-descriptions-item>
                                    <el-descriptions-item label="昵  称">{{ this.originalForm.nickname }}</el-descriptions-item>
                                    <el-descriptions-item label="积  分">{{ this.originalForm.score }}</el-descriptions-item>
                                    <el-descriptions-item label="加入时间">{{ this.originalForm.createtime | formatDate }}</el-descriptions-item>
                                    <el-descriptions-item label="最后登录">{{ this.originalForm.prevtime | formatDate }}</el-descriptions-item>
                                </el-descriptions>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="profile" label="个人资料" style="margin-left: 20px;">
                    <div class="rightMain">
                        <div class="userInfo-Top">
                            <span>编辑资料</span>
                        </div>
                        <div class="UpuserInfo-Bottom">
                            <el-form
                                ref="userForm"
                                :model="form"
                                :rules="rules"
                                label-width="100px"
                                label-position="left"
                                style="max-width: 600px;"
                                >
                                <!-- 头像上传 -->
                                <el-form-item label="头像">
                                    <el-upload
                                        class="avatar-uploader"
                                        action="https://api.xibaba888.com/api/upload/upload"
                                        :on-success="handleAvatarSuccess"
                                        :show-file-list="false"
                                        :before-upload="beforeAvatarUpload"
                                        >
                                        <img v-if="userAvatar" :src="'https://api.goucaiwang888.com'+userAvatar" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>

                                <!-- 用户名 -->
                                <el-form-item label="用户名" prop="username">
                                    <el-input v-model="form.username"></el-input>
                                </el-form-item>

                                <!-- 昵称 -->
                                <el-form-item label="昵称" prop="nickname">
                                    <el-input v-model="form.nickname"></el-input>
                                </el-form-item>

                                <!-- 个人介绍 -->
                                <el-form-item label="个人介绍" prop="bio">
                                    <el-input
                                    type="textarea"
                                    v-model="form.bio"
                                    :autosize="{ minRows: 3, maxRows: 5 }"
                                    placeholder="介绍一下你自己..."
                                    ></el-input>
                                </el-form-item>

                                <!-- 邮箱 -->
                                <el-form-item label="邮箱" prop="email">
                                    <el-input v-model="form.email"></el-input>
                                </el-form-item>

                                <!-- 手机号 -->
                                <el-form-item label="手机号" prop="mobile">
                                    <el-input :disabled="true" v-model="form.mobile"></el-input>
                                </el-form-item>

                                <!-- 按钮组 -->
                                <el-form-item>
                                    <el-button type="primary" @click="submitForm">保存</el-button>
                                    <el-button @click="resetForm">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="proPassword" label="修改密码" style="margin-left: 20px;">
                    <div class="rightMain">
                        <div class="userInfo-Top">
                            <span>修改密码</span>
                        </div>
                        <div class="UpuserInfo-Bottom">
                            <el-form
                                ref="passWordForm"
                                :model="passWordForm"
                                :rules="rules"
                                label-width="100px"
                                label-position="left"
                                style="max-width: 600px;"
                                >

                                <!-- 原密码 -->
                                <el-form-item label="原密码" prop="old_password">
                                    <el-input show-password v-model="passWordForm.old_password"></el-input>
                                </el-form-item>

                                <!-- 新密码 -->
                                <el-form-item label="新密码" prop="password">
                                    <el-input show-password v-model="passWordForm.password"></el-input>
                                </el-form-item>

                                <!-- 确认密码 -->
                                <el-form-item label="确认密码" prop="password_confirm">
                                    <el-input show-password v-model="passWordForm.password_confirm"></el-input>
                                </el-form-item>

                                <!-- 按钮组 -->
                                <el-form-item>
                                    <el-button type="primary" @click="passWordSubForm">保存</el-button>
                                    <el-button @click="resetpassForm">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="vipList" label="VIP列表">
                  <!-- 微信扫码支付弹窗 -->
                   <el-dialog
                       title=""
                       :visible.sync="qrDialogVisible"
                       width="440px"
                       :close-on-click-modal="false"
                       :show-close="false"
                       class="pay-dialog"
                     >
                       <div class="qr-container">
                         <!-- 支付类型提示 -->
                         <div class="pay-type-label" :class="selectedPayMethod">
                           <i v-if="selectedPayMethod==='wechat'" class="el-icon-chat-dot-square"></i>
                           <i v-if="selectedPayMethod==='alipay'" class="el-icon-bank-card"></i>
                           <span>{{ selectedPayMethod === 'wechat' ? '微信扫码支付' : '支付宝扫码支付' }}</span>
                         </div>

                         <!-- 倒计时 -->
                         <div class="circle-wrapper">
                           <div class="time-text">{{ remainingTime }}s</div>
                         </div>

                         <!-- 二维码 -->
                         <div v-if="qrCodeUrl" class="qr-code-wrap">
                           <img :src="qrCodeUrl" alt="扫码支付" class="qr-code-img" />
                         </div>
                         <div v-else class="loading-text">生成二维码中...</div>
                       </div>

                       <div class="pay-footer">
                         <el-button type="danger" @click="cancelQrPay">取消支付</el-button>
                       </div>
                     </el-dialog>
                  <!-- 支付结果 -->
                  <div v-if="payStatus === 'SUCCESS'" class="success-msg">
                    ✅ 支付成功！
                  </div>
                  <div class="vip-container">
                    <!-- 当前会员等级 -->
                    <div class="vip-header">
                      <div class="vip-info">
                        <h2 class="vip-level">{{ viplist.name }}</h2>
                        <p class="vip-expire">到期时间：{{ vipExpireTime || '未开通' }}</p>
                      </div>
                    </div>

                    <!-- 会员权益 -->
                    <div class="vip-section">
                      <h3 class="vip-title">✨ 会员权益</h3>
                      <el-row :gutter="20">
                        <el-col v-for="(benefit,index) in viplist.rightdata" :key="index" :span="6">
                          <el-card shadow="hover" class="benefit-card">
                            <div class="benefit-icon-wrap">
                              <img :src="benefit.image" class="benefit-icon" />
                            </div>
                            <h4 class="benefit-text">{{ benefit.text }}</h4>
                            <p class="benefit-intro">{{ benefit.intro }}</p>
                          </el-card>
                        </el-col>
                      </el-row>
                    </div>

                    <!-- 会员套餐 -->
                    <div class="vip-section">
                      <h3 class="vip-title">💎 会员套餐</h3>
                      <el-radio-group v-model="selectedPackage" size="large" >
                        <el-radio-button
                          v-for="pkg in viplist.pricedata"
                          :label="pkg"
                          :key="pkg.days"
                        >
                          <div class="pkg-title">（{{ pkg.days }}天）{{ pkg.title }}</div>
                          <div class="pkg-price">￥{{ pkg.price }}</div>
                        </el-radio-button>
                      </el-radio-group>
                    </div>

                    <!-- 支付方式 -->
                    <div class="vip-section">
                      <h3 class="vip-title">💳 支付方式</h3>
                      <el-radio-group v-model="selectedPayMethod" class="pay-method-group">
                        <el-radio label="wechat" class="pay-option">
                          <i class="el-icon-chat-dot-square pay-icon wechat"></i> 微信支付
                        </el-radio>
                        <el-radio label="alipay" class="pay-option">
                          <i class="el-icon-bank-card pay-icon alipay"></i> 支付宝
                        </el-radio>
                      </el-radio-group>
                    </div>

                    <!-- 支付按钮 -->
                    <div class="vip-section pay-btn-wrap">
                      <el-button type="primary" size="large" class="vip-pay-btn" @click="handlePay">立即支付</el-button>
                    </div>
                  </div>
                </el-tab-pane>


                <el-tab-pane name="vipRecord" label="VIP记录">VIP记录</el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import Breadcrumb from '../components/Breadcrumb.vue';
import { getUserInfo,updateUserInfo,uploadAvatar } from "../api/login"
import {getVipList} from "../api/vip.js"
import { pay, checkStatus } from "@/api/pay";
import QRCode from 'qrcode';
export default {
    name: 'App',
    components: {
        Breadcrumb
    },
    data(){
        const validateEmail = (rule, value, callback) => {
            if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                callback(new Error('请输入正确的邮箱地址'));
            } else {
                callback();
            }
        };

        // 手机号验证规则
        const validatePhone = (rule, value, callback) => {
            if (value && !/^1[3-9]\d{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号码'));
            } else {
                callback();
            }
        };

        const validatePassword = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入密码'));
            } else if (value.length < 6) {
                callback(new Error('密码长度不能少于6位'));
            } else {
                callback();
            }
        };

        const validateConfirmPassword = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.passWordForm.password) {
                callback(new Error('两次输入的密码不一致'));
            } else {
                callback();
            }
        };
        return {
            payStatus: '', // 默认值，'WAITING_QR' | 'SUCCESS' | 'FAIL'
            timeout: 3 * 60, // 秒
            remainingTime: 180, // 秒
            qrDialogVisible: false,   // <---- 确保这里有
            qrCodeUrl: '',
            payPollingTimer: null,
            orderCreateTime: null,
            orderTimeout: 30 * 60 * 1000, // 30分钟
            loading: false,
            userVipLevel: "VIP0",
            vipExpireTime: "",
            selectedPackage: 1,
            selectedPackage: { title: "日享会员", days: 1, price: 3 },
            selectedPayMethod: "wechat",
            viplist: {},
            vipBenefits: [
                { title: "专属标识", icon: "el-icon-star-on" },
                { title: "加速服务", icon: "el-icon-s-claim" },
                { title: "优先客服", icon: "el-icon-service" },
                { title: "更多特权", icon: "el-icon-service" }
              ],
            // vipPackages: [
            //     { label: "日享会员", value: "day", price: 3 },
            //     { label: "月享会员", value: "month", price: 60 },
            //     { label: "半年尊享", value: "halfyear", price: 360 },
            //     { label: "年度尊享", value: "year", price: 720 }
            //   ],

            activeTab: 'userInfo',
            circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
            form: {
                username: '',
                nickname: '',
                bio: '',
                email: '',
                mobile: ''
            },
            passWordForm:{
                password:'',
                old_password:'',
                password_confirm:''
            },
            originalForm: {},
            rules: {
                nickname: [
                    { required: true, message: '请输入昵称', trigger: 'blur' },
                    { min: 2, max: 12, message: '长度在 2 到 12 个字符', trigger: 'blur' }
                ],
                email: [
                    { validator: validateEmail, trigger: 'blur' }
                ],
                mobile: [
                    { validator: validatePhone, trigger: 'blur' }
                ],
                old_password: [
                    { required: true, message: '请输入原密码', trigger: 'blur' }
                ],
                password: [
                    { required: true, validator: validatePassword, trigger: 'blur' }
                ],
                password_confirm: [
                    { required: true, validator: validateConfirmPassword, trigger: 'blur' }
                ]
            }
        }
    },
    filters: {
        formatDate(timestamp) {
            return new Date(timestamp * 1000).toLocaleString()
        }
    },
    computed: {
        userAvatar() {
            console.log(this.$store.state.user.avatar,'this.$store.state.user.avatar')
            return this.$store.state.user.avatar || this.originalForm.avatar;
        }
    },
    created() {
        const savedUser = JSON.parse(localStorage.getItem('user'));
        if (savedUser) {
            this.$store.commit('UPDATE_USER_INFO', savedUser);
            this.originalForm = { ...savedUser };
        }
        this.fetchUserData();

    },
    methods:{
        handleLogout(){
            this.$store.dispatch('logout').then(() => {
                this.$message.success('退出登录成功')
                // 如果需要跳转到首页
                this.$router.push('/')
                }).catch(error => {
                this.$message.error('退出登录失败')
                console.error(error)
            })
        },
        goEdit(){
            this.activeTab = 'profile';
        },
        async fetchUserData() {
            try {
                const response = await getUserInfo();
                if(response.data.code === 1){
                    this.form = response.data.data;
                    this.originalForm = JSON.parse(JSON.stringify(response.data.data));
                    console.log(this.originalForm);
                    this.$store.commit('UPDATE_USER_INFO', response.data.data);
                }
                const response2 = await getVipList();
                if(response2.data.code === 1){
                    // console.log(response2.data.data);
                    this.viplist = response2.data.data['vipList'][0];
                    this.vipExpireTime = response2.data.data.vip_end_hint
                    // this.originalForm = JSON.parse(JSON.stringify(response.data.data));
                    console.log(this.vipExpireTime);
                    if (this.viplist.pricedata.length > 0) {
                          this.selectedPackage = this.viplist.pricedata[0] // 默认选中第一个
                    }
                }

            } catch (error) {
                this.$message.error('获取用户数据失败');
                console.error(error);
            }
        },
        async handleAvatarSuccess(res, file) {
            console.log(res,'res')
            console.log(file,'file')
            try {
                if (res && res.data && res.data.url) {
                    await updateUserInfo({ avatar: res.data.url });
                    this.$store.commit('UPDATE_USER_AVATAR', res.data.url);
                    this.originalForm.avatar = res.data.url;
                    this.$message.success('头像更新成功');
                }
            } catch (error) {
                this.$message.error('头像更新失败');
                console.error(error);
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        async submitForm() {
            this.$refs.userForm.validate(async (valid) => {
                if (valid) {
                    try {
                        // 这里替换为实际的API调用
                        console.log(this.form,'updateUserInfo')
                        const params = {
                            username: this.form.username,
                            nickname: this.form.nickname,
                            bio: this.form.bio,
                            email: this.form.email
                        }
                        await updateUserInfo(params);
                        this.$store.commit('UPDATE_USER_INFO', {
                            username: this.form.username
                        });
                        this.originalForm = JSON.parse(JSON.stringify(this.form));
                        this.$message.success('保存成功');
                    } catch (error) {
                        this.$message.error('保存失败');
                        console.error(error);
                    }
                } else {
                    this.$message.error('请检查表单填写是否正确');
                    return false;
                }
            });
        },
        async passWordSubForm() {
            this.$refs.passWordForm.validate(async (valid) => {
                if (valid) {
                    try {
                        // 这里替换为实际的修改密码API调用
                        const response = await updateUserInfo({
                            old_password: this.passWordForm.old_password,
                            password: this.passWordForm.password,
                            password_confirm: this.passWordForm.password_confirm
                        });
                        console.log(response,'response')
                        if (response.data.code === 1) {
                            this.$message.success('密码修改成功');
                            this.resetpassForm();
                        } else {
                            this.$message.error(response.data.msg || '密码修改失败');
                        }
                    } catch (error) {
                        this.$message.error('密码修改失败');
                        console.error(error);
                    }
                } else {
                    this.$message.error('请检查表单填写是否正确');
                    return false;
                }
            });
        },
        resetpassForm() {
            this.passWordForm = {
                password: '',
                old_password: '',
                password_confirm: ''
            };
            this.$refs.passWordForm.clearValidate();
        },
        resetForm() {
            this.form = JSON.parse(JSON.stringify(this.originalForm));
            this.$refs.userForm.clearValidate();
        },
        async handlePay() {
          const params = {
             days: this.selectedPackage.days,
             channel: this.selectedPayMethod, // "alipay" / "wechat"
             method: "web"
          };

          const result = await pay(params);
          if (!result.success) {
            this.$message.error(result.message);
            return;
          }

          // H5 / 支付宝直接跳转
          if (result.payUrl) {
            window.location.href = result.payUrl;
            return;
          }

          // 微信扫码支付
          if (result.qrcode) {
            this.qrDialogVisible = true;
            this.orderCreateTime = Date.now();
            this.currentOrderId = result.orderId;

            this.qrCodeUrl = await QRCode.toDataURL(result.qrcode);
            // 等 DOM 渲染完成再启动倒计时
            this.$nextTick(() => {

              this.remainingTime = this.timeout; // 重置倒计时
              this.startCountdown();
              this.startPayPolling(result.orderId);

            });
          }
        },

        startCountdown() {
                this.countdownTimer = setInterval(() => {
                  if (this.remainingTime <= 0) {
                    clearInterval(this.countdownTimer);
                    this.payStatus = "FAIL";
                    this.qrDialogVisible = false;
                    this.qrCodeUrl = "";
                    this.$message.error("支付超时，请重新尝试");
                    if (this.payPollingTimer) clearInterval(this.payPollingTimer);
                    return;
                  }
                  this.remainingTime--;

                }, 1000);
            },

        startPayPolling(orderId) {
              if (this.payPollingTimer) clearInterval(this.payPollingTimer);

              this.payPollingTimer = setInterval(async () => {
                const statusRes = await checkStatus(orderId);

                if (statusRes.status === "PAID") {
                  clearInterval(this.payPollingTimer);
                  clearInterval(this.countdownTimer);
                  this.qrDialogVisible = false;
                  this.payStatus = "SUCCESS";
                  this.$message.success("支付成功！");
                  this.fetchUserData && this.fetchUserData();
                } else if (statusRes.status === "EXPIRED" || statusRes.status === "FAIL") {
                  clearInterval(this.payPollingTimer);
                  clearInterval(this.countdownTimer);
                  this.qrDialogVisible = false;
                  this.qrCodeUrl = "";
                  this.payStatus = "FAIL";
                  this.$message.error("支付失败");
                }
              }, 5000);
            },

      cancelQrPay() {
          if (this.payPollingTimer) clearInterval(this.payPollingTimer);
          this.qrDialogVisible = false;
          this.qrCodeUrl = '';
          this.payStatus = 'FAIL'; // 用户主动取消也判失败
      }




    }
}
</script>
<style scoped>
.wrap1200 {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.mineMain {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  min-height: 450px;
}

/* 用户信息顶部 */
.userInfo-Top {
  height: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 22px;
  margin-right: 7px;
}
.userInfo-Top span {
  font-size: 16px;
  font-weight: bold;
}
.userInfo-Top .el-button--text {
  color: #666;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 2px 8px;
  padding: 5px;
  /* font-weight: bold; */
  transition: all 0.2s ease; /* 平滑过渡 */
}

.userInfo-Top .el-button--text:hover {
  color: #EA4747;              /* 文字变红 */
  border-color: #EA4747;       /* 边框变红 */
  transform: scale(1.05);      /* 悬停时轻微放大 */
}

.userInfo-Top .el-button--text:active {
  transform: scale(0.95);      /* 点击时轻微缩小 */
}


.userInfo-Bottom {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.userInfo-BLeft {
  width: 15%;
}
.userInfo-BRight {
  width: 85%;
  display: flex;
  align-items: center;
}

/* 编辑资料头像上传 */
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}
.avatar-uploader:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

/* VIP 页面容器 */
.vip-container {
  padding: 20px;
  background: #fff;
  border-radius: 12px;
}

/* 顶部会员卡片 */
.vip-header {
  background: linear-gradient(135deg, #ffdf8c, #FFB347);
  border-radius: 12px;
  padding: 20px;
  color: #fff;
  text-align: center;
  margin-bottom: 30px;
}
.vip-level {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
}
.vip-expire {
  font-size: 14px;
  opacity: 0.9;
  color: #5C3A00;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}

/* 区块标题 */
.vip-title {
  font-size: 18px;
  margin-bottom: 16px;
  font-weight: bold;
  color: #333;
}

/* 权益卡片 */
.benefit-card {
  text-align: center;
  border-radius: 16px;
  padding: 20px;
  transition: 0.3s;
}
.benefit-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}
.benefit-icon-wrap {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: linear-gradient(135deg, #fbc2eb, #a6c1ee);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}
.benefit-icon {
  width: 40px;
  height: 40px;
}
.benefit-text {
  font-weight: bold;
  margin: 8px 0 4px;
}
.benefit-intro {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}

/* 套餐选择 */
.vip-package-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.pkg-title {
  font-size: 15px;
  margin-bottom: 10px;
}
.pkg-price {
  font-size: 18px;
  font-weight: bold;
  color: #e53935;
}


/* 支付方式 */
.pay-method-group {
  display: flex;
  gap: 20px;
}
.pay-option {
  display: flex;
  align-items: center;
  font-size: 15px;
}
.pay-icon {
  font-size: 20px;
  margin-right: 6px;
}
.pay-icon.wechat {
  color: #1aad19;
}
.pay-icon.alipay {
  color: #1677ff;
}

/* 支付按钮 */
.pay-btn-wrap {
  text-align: center;
  margin-top: 20px;
}
.vip-pay-btn {
  padding: 12px 40px;
  font-size: 18px;
  border-radius: 8px;
  background: linear-gradient(135deg, #ff9800, #ff5722);
  border: none;
}
.vip-pay-btn:hover {
  opacity: 0.9;
}
.qr-code-wrap {
  text-align: center;
}
.qr-code-img {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}
.pay-dialog ::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #1aad19, #1aad50); /* 默认微信色 */
  color: #fff;
  font-weight: bold;
  text-align: center;
}

.pay-dialog ::v-deep .el-dialog__header.alipay {
  background: linear-gradient(135deg, #1677ff, #69a1ff); /* 支付宝蓝色 */
}

.qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pay-type-label {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}

.pay-type-label.wechat {
  color: #1aad19;
}

.pay-type-label.alipay {
  color: #1677ff;
}

.pay-type-label i {
  font-size: 24px;
  margin-right: 8px;
}

.circle-wrapper {
  position: relative;
  width: 150px;
  height: 30px;
  margin-bottom: 10px;
}

.time-text {
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 24px;
  color: #FF5722;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}

.qr-code-wrap {
  width: 200px;
  height: 200px;
  border: 2px solid #FF9800;
  border-radius: 12px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}

.qr-code-img {
  width: 100%;
  height: 100%;
}

.loading-text {
  text-align: center;
  font-size: 16px;
  color: #666;
}

.pay-footer {
  margin-top: 20px;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/views/mine.vue